import React, { Component } from 'react';
import { withUserContext } from "../../../contexts/UserContext";
import { withNotificationContext } from "../../../contexts/NotificationContext";
import './Reports.scss'
import SelectField from '../SharedComponents/SelectField/SelectField';
import { MDBCol, MDBRow } from 'mdbreact';
import SearchSelectField from '../SharedComponents/SearchSelectField';
import BasicCheckbox from '../SharedComponents/BasicCheckbox/BasicCheckbox';
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";


class DealWorksheet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportDetails:{},
            billingOptions:[],
            unionList:[]
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (props.reportDetails !== state.reportDetails) {
            return {
                reportDetails: props.reportDetails
            }
        }
        return null
    }
   
   
   
    render() {
        return (
            <div className="DealWorksheetContainer">
             <MDBRow>
                <MDBCol md={7}>
                <SearchSelectField
                    id="project_id"
                    options={this.props?.projectList}
                    searchSelect={true}
                    multiple={false}
                    label={"Select Project"}
                    placeholder={"Select Project"}
                    detail_selected={this.props?.selectedprojectValue}
                    valueSelected={(e,value) => this.props?.handleOnChange("project_id", value)}
                    searchText={(e) => this.props?.getLookupValues('PROJECT',e.target.value)}
                />
                </MDBCol>
             </MDBRow>
             {/* <MDBRow>
                <MDBCol md={10}  style={{ marginTop: "-6px" }}>
                    <MDBRow>
                        <MDBCol md={9}>
                            <BasicCheckbox 
                                id={"is_deal_worksheet_schedule_f"}
                                label={"Deal Worksheet - Schedule F"}
                                checked={this.props.reportDetails?.is_deal_worksheet_schedule_f === 1 ? true : false}
                                onChange={(e) => this.props?.handleOnChange("is_deal_worksheet_schedule_f", e.target.checked)}
                           />
                        </MDBCol>
                    </MDBRow>
                </MDBCol>
             </MDBRow> */}
             <MDBRow>
                <MDBCol md={5} className="longWidth">
                <SearchSelectField
                    id="talent_id"
                    label={"Performer"}
                    placeholder={"Select Performer"}
                    options={this.props?.PerformerValue}
                    searchSelect={true}
                    multiple={false}
                    detail_selected={this.props?.selectedTalentValue}
                    valueSelected={(e,value) => this.props?.handleOnChange("talent_id", value)}
                    searchText={(e) => this.props?.getPerformerValues("PROJECT_PERFORMERS",e.target.value,value)}
                />
                </MDBCol>
             </MDBRow>
             <MDBRow>
                    <MDBCol className="radio-font">
                        <FormControl>
                            <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label1"
                            name="row-radio-buttons-group"
                            className="radio-font1"
                            value={this.props.reportDetails?.confidentiality}
                            onChange={(e) => 
                                {
                                console.log("confidentiality:", e.target.value);
                                this.props?.handleOnChange("confidentiality", Number(e.target.value))
                                }
                                }
                            >
                            <FormControlLabel
                                className="radioLabel"
                                value={1}
                                control={<Radio />}
                                label="Confidential"
                            />
                            <FormControlLabel
                                className="radioLabel"
                                value= {0}
                                control={<Radio />}
                                label="Non-Confidential"
                            />
                            </RadioGroup>
                        </FormControl>
                    </MDBCol>
            </MDBRow>
            {this.props.reportDetails?.confidentiality === 0 && 
                <MDBRow>
                    <MDBCol className="radio-font">
                        <BasicCheckbox 
                            id={"is_ssn_loan_out_address_phone_email"}
                            label={"SSN/Loan out, Address, Phone/Email"}
                            checked={this.props.reportDetails?.is_ssn_loan_out_address_phone_email === 1 ? true : false}
                            onChange={(e) => this.props?.handleOnChange("is_ssn_loan_out_address_phone_email", e.target.checked)}
                        />
                        <BasicCheckbox 
                            id={"is_deal_information"}
                            label={"Deal Information "}
                            checked={this.props.reportDetails?.is_deal_information === 1 ? true : false}
                            onChange={(e) => this.props?.handleOnChange("is_deal_information", e.target.checked)}
                        />
                        <BasicCheckbox 
                            id={"is_work_activity"}
                            label={"Work Activity"}
                            checked={this.props.reportDetails?.is_work_activity === 1 ? true : false}
                            onChange={(e) => this.props?.handleOnChange("is_work_activity", e.target.checked)}
                        />
                        <BasicCheckbox 
                            id={"is_perks"}
                            label={"Perks"}
                            checked={this.props.reportDetails?.is_perks === 1 ? true : false}
                            onChange={(e) => this.props?.handleOnChange("is_perks", e.target.checked)}
                        />
                    </MDBCol>
                </MDBRow>
            }
             <MDBRow>
                <span className='optionFilterColor'>Optional Filters</span>
             </MDBRow>
             <MDBRow>
                <MDBCol md={5} className="longWidth">
                    <SelectField 
                        label={"Production Company"}
                        value={this.state.reportDetails?.production_company}
                        // options={this.props?.newProdCompanies}
                        options={this.props?.companyList}
                        onChange={(e) => this.props?.handleOnChange("production_company", e.target.value)}
                    />
                </MDBCol>
             </MDBRow>
             <MDBRow>
                <MDBCol md={5} className="longWidth">
                    <SelectField 
                        label={"Union"}
                        value={this.state.reportDetails?.union}
                        options={this.props.unionList}
                        onChange={(e) => this.props?.handleOnChange("union", e.target.value)}
                    />
                </MDBCol>
             </MDBRow>
             <MDBRow >
                <MDBCol md={10}  >
                    <MDBRow>
                    <MDBCol id={"perId"} md={6}>
                        <SelectField 
                            label={"Performer Type"}
                            value={this.state.reportDetails?.performer_type}
                            options={this.props.performerTypeOptions}
                            onChange={(e) => this.props?.handleOnChange("performer_type", e.target.value)}
                        />
                    </MDBCol>
                    <MDBCol id={"feeId"} md={6}>
                        <SelectField 
                            label={"Fee Type"}
                            value={this.state.reportDetails?.fee_type}
                            options={this.props.feeOptions}
                            onChange={(e) => this.props?.handleOnChange("fee_type", e.target.value)}
                        />
                    </MDBCol>
                    </MDBRow>
                </MDBCol>
             </MDBRow>
            </div>
        );
    }

}
export default withUserContext(withNotificationContext(DealWorksheet));